import { instance } from '@/utils/request'

// 行为数据采集接口
export function behaviorCollect(params) {
  return instance({
    url: '/dataware/behaviorCollect',
    method: 'post',
    data: params
  })
}
